import React, { PropsWithChildren } from 'react';
import { cn } from '@/utils';
interface Props {
  value?: string;
  htmlFor?: string;
  className?: string;
}

export default function InputLabel({
  value,
  htmlFor,
  className,
  children,
  ...rest
}: PropsWithChildren<Props>) {
  return (
    <label
      className={cn(
        'block cursor-pointer text-sm font-medium text-brand-dark-100/90 dark:text-brand-light-25',
        className,
      )}
      htmlFor={htmlFor}
      {...rest}
    >
      {value || children}
    </label>
  );
}
